import React, { useEffect, useState } from 'react';
import { useUserRegion } from '../../hooks/useUserRegion';
import { trackEvent } from '../../hooks/useMetaPixel';
export function StickyMobileCTA() {
  const {
    formattedPrice,
    loading
  } = useUserRegion();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`
        fixed bottom-0 left-0 right-0 z-40 md:hidden
        bg-dark/95 backdrop-blur-sm border-t-2 border-amber
        shadow-[0_-4px_20px_rgba(0,0,0,0.5)]
        px-4 py-3
        transition-transform duration-300 ease-out
        ${isVisible ? 'translate-y-0' : 'translate-y-full'}
      `} data-id="element-302">
      <div className="flex items-center justify-between" data-id="element-303">
        <div className="flex flex-col" data-id="element-304">
          <span className="font-playfair text-amber font-bold text-sm" data-id="element-305">
            Resin Without Errors™
          </span>
          <span className="font-lato text-cream/70 text-xs" data-id="element-306">
            7-Day System — HD Video + Guides
          </span>
        </div>

        <a href="https://flawless-resin.shop/cart/48237768278271:1" target="_blank" rel="noopener noreferrer" onClick={() => {
        trackEvent('AddToCart', {
          content_name: 'Resin Without Errors',
          content_type: 'product',
          value: formattedPrice,
          currency: 'USD'
        });
      }} className="
            flex-1 inline-flex items-center justify-center text-center
            bg-amber text-dark font-bold font-lato rounded-lg
            transition-all duration-300 ease-out
            active:scale-[0.98]
            px-4 py-3 text-sm
            shadow-[0_0_15px_rgba(212,160,23,0.3)]
          " data-id="element-307">
          {loading ? <span className="flex items-center justify-center" data-id="element-308">
              <span className="animate-spin mr-2" data-id="element-309">⏳</span>
              {formattedPrice}
            </span> : <span className="flex items-center justify-center" data-id="element-310">
              {formattedPrice}
            </span>}
        </a>
      </div>
    </div>;
}